<script setup lang="ts">
import { computed, ref } from 'vue'
import { ElTooltip } from 'element-plus'

const props = defineProps({
  keep: {type:Boolean,default:false},
  tips: {type:[String,Array,Object],default:''},
  lineClamp: {type:Number,default:0},
  disabled: {type:Boolean,default:false},
  placement: {type:String,default:'top'},
  trigger: {type:String, default:'hover'},
  popperClass: {type:String,default:''},
})

const textOverflow = ref(false)
const refContent = ref<any>(null)

const style = computed(():any => {
  return {
    overflow:'hidden',
    display: props.lineClamp>1?'-webkit-box':'',
    lineClamp: props.lineClamp>1?props.lineClamp:null, // 可通过lineClamp设置超出两行再显示省略号
    whiteSpace: props.lineClamp>1?'normal':'nowrap',
    wordWrap: props.lineClamp>1?'normal':'break-word',
    boxOrient: props.lineClamp>1?'vertical':null,
    textOverflow: 'ellipsis',
  }
})
const isDisabled = computed(() => {
  if (props.disabled) return true
  if (props.keep) return false
  return !textOverflow.value
})

const isTextOverflow = (e:any) => {
  const target = e.target
  if (target) {
    if (props.lineClamp === 0) {
      if (target.clientWidth < target.scrollWidth) textOverflow.value = true
      else textOverflow.value = false
    } else {
      if (target.clientHeight < target.scrollHeight) textOverflow.value = true
      else textOverflow.value = false
    }
  }
}
const contentType = () => {
  if (Array.isArray(props.tips)) return 'Array'
  if (typeof props.tips === 'object') return 'Object'
  return 'String'
}
</script>
<template>
  <el-tooltip
    :disabled="isDisabled"
    :placement="placement"
    effect="light"
    :trigger="trigger"
    :popper-class="props.popperClass">
    <template #content>
      <div>
        <div v-if="contentType()==='Object'">
          <div v-for="key,index of Object.keys(tips)" :key="index">{{ `${key}: ${tips[key]}` }}</div>
        </div>
        <div v-if="contentType()==='Array'">
          <div v-for="item,index of tips" :key="index">{{ item }}</div>
        </div>
        <div v-if="contentType()==='String'">{{ tips }}</div>
      </div>
    </template>
    <div
      ref="refContent" 
      @mouseover="isTextOverflow"
      :style="style">
      <slot></slot>
      <!-- <div ref="refContentInner" style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;word-wrap:break-word">
        <slot></slot>
      </div> -->
    </div>
  </el-tooltip>
</template>

<style lang="less" scoped>
</style>